import React from 'react';
import { searchResultsProductsPropTypes } from './SearchResultsProductsPropTypes';
import Picture from '@Theme/natucare/components/Picture/Picture';
import Button from '@Theme/natucare/components/Button/Button';
import * as styles from './SearchResultsProducts.module.scss';
const SearchResultsProducts = ({
  title,
  items,
  button
}) => {
  if (!title && !items && !button) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.rootTitle
  }, title), items && /*#__PURE__*/React.createElement("div", {
    className: styles.rootWrapper
  }, items.map((item, index) => {
    var _item$picture, _item$picture2;
    const pictureData = {
      xs: {
        src: (_item$picture = item.picture) === null || _item$picture === void 0 ? void 0 : _item$picture.src
      },
      alt: (_item$picture2 = item.picture) === null || _item$picture2 === void 0 ? void 0 : _item$picture2.alt
    };
    return /*#__PURE__*/React.createElement("a", {
      href: item.href,
      className: styles.rootTileLink,
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.rootPictureWrapper
    }, /*#__PURE__*/React.createElement(Picture, Object.assign({}, pictureData, {
      pictureClassname: styles.rootPicture,
      imgClassname: styles.rootImage
    })), item.labels && /*#__PURE__*/React.createElement("div", {
      className: styles.rootPictureLabelWrapper
    }, item.labels.map((label, labelIndex) => /*#__PURE__*/React.createElement("span", {
      className: styles.rootPictureLabel,
      key: labelIndex
    }, label)))), /*#__PURE__*/React.createElement("div", {
      className: styles.rootProduct
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.rootProductVendor
    }, item.vendor), /*#__PURE__*/React.createElement("span", {
      className: styles.rootProductTitle
    }, item.title), /*#__PURE__*/React.createElement("div", {
      className: styles.rootProductPriceWrapper
    }, item.price.sale && /*#__PURE__*/React.createElement("span", {
      className: `${styles.rootProductPrice} ${styles.rootProductPriceSale}`
    }, item.price.sale.toFixed(2), " ", item.price.currency), /*#__PURE__*/React.createElement("span", {
      className: `${styles.rootProductPrice} ${styles.rootProductPriceRegular}`
    }, item.price.regular.toFixed(2), " ", item.price.currency))));
  })), /*#__PURE__*/React.createElement(Button, {
    label: button.label,
    href: button.href,
    variant: "quaternary",
    classname: styles.rootButton
  }));
};
export default SearchResultsProducts;